var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgTodoUndone = function SvgTodoUndone(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "\\u56FE\\u5C42 1",
    viewBox: "0 0 1024 1024"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M512 51.2C257.64 51.2 51.2 257.64 51.2 512S257.64 972.8 512 972.8 972.8 766.36 972.8 512 766.36 51.2 512 51.2Zm0 829.44c-203.67 0-368.64-164.97-368.64-368.64S308.33 143.36 512 143.36 880.64 308.33 880.64 512 715.67 880.64 512 880.64Z"
  })));
};
export default SvgTodoUndone;